import React, { PureComponent } from 'react';


class Item extends PureComponent {

  render() {
    const { title, description } = this.props;
    return (
      <div className="list-item">
        <h4 className="list-item__title">{title}</h4>
        <p>{description}</p>
      </div>
    );
  }
}

Item.propTypes = {};
Item.defaultProps = {};

export default Item;



// WEBPACK FOOTER //
// ./src/components/List/Item.js